import { Field, Form, FormSpy, useForm, useFormState } from 'react-final-form';
import { useVehicleListContext } from '../../context';
import styled from 'styled-components';
import { FormTextField } from 'components';
import { Button, MenuItem } from '@material-ui/core';
import { debounce } from 'utils';
import { FormState } from 'redux-form';
import { useCallback, useRef } from 'react';
import { useGetAuctionAgentsQuery } from 'services/api/admin-auction-vehicles';
import { AdditionalFinalFormFilters } from 'components/Form/FinalForm/AdditionalFinalFormFilters';
import { ADMIN_VEHICLE_LIST_DYNAMIC_FILTERS } from 'constants/filters';
import { useCurrentUser } from 'hooks/selectors';
import { RenderSellerForm } from './SellerFilterForm';

const PatchedFormTextField = FormTextField as any;

const submit = () => {};

const toUpperCase = value => value && value.toUpperCase();

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 12px;
  min-width: 320px;
`;

type Props = {
  onNewAdditionalFilter?: () => void;
};

export const FilterForm = ({ onNewAdditionalFilter }: Props) => {
  const { getFilters } = useVehicleListContext();
  const initialFilters = useRef(getFilters()).current;

  const user = useCurrentUser();
  const FormComponent = user.role === 'seller' ? RenderSellerForm : RenderForm;

  return (
    <Form initialValues={initialFilters} onSubmit={submit}>
      {() => (
        <>
          <FilterSpy />
          <FormComponent onNewAdditionalFilter={onNewAdditionalFilter} />
        </>
      )}
    </Form>
  );
};

const RenderForm = ({ onNewAdditionalFilter }: Props) => {
  const { data: agents = [] } = useGetAuctionAgentsQuery({ auctionId: '*' });
  const form = useForm();
  const formState = useFormState();

  const hasValues = formState.values && Object.keys(formState.values).length > 0;

  return (
    <Wrapper>
      <Field component={PatchedFormTextField} name="vin" label="VIN Search" parse={toUpperCase} />
      <Field component={PatchedFormTextField} name="dealership_name" label="Seller Search" />
      <Field component={PatchedFormTextField} name="status" label="Filter by Vehicle State" select>
        <MenuItem value="">All</MenuItem>
        <MenuItem value="awarded">Awarded</MenuItem>
        <MenuItem value="active">Active</MenuItem>
        <MenuItem value="pulled">Pulled</MenuItem>
        <MenuItem value="draft">Draft</MenuItem>
        <MenuItem value="deactivated">Deactivated</MenuItem>
        <MenuItem value="under_review">Under Review</MenuItem>
      </Field>
      <Field component={PatchedFormTextField} name="auction_type" label="Filter by Auction" select>
        <MenuItem value="">All</MenuItem>
        <MenuItem value="autoaxess">Autoaxess</MenuItem>
        <MenuItem value="frontline">Frontline</MenuItem>
        <MenuItem value="second_chance">Second Chance</MenuItem>
      </Field>
      <Field component={PatchedFormTextField} name="lister_id" label="Filter by Inspector" select>
        <MenuItem value="">All</MenuItem>
        {agents.map(agent => (
          <MenuItem
            key={agent.agent_id}
            value={agent.agent_id}
          >{`${agent.agent_name} (${agent.amount_listed})`}</MenuItem>
        ))}
      </Field>
      <Field component={PatchedFormTextField} name="order_by" label="Sort By" select>
        <MenuItem value="default">Most Recent</MenuItem>
        <MenuItem value="by_seller">By Seller</MenuItem>
      </Field>
      <AdditionalFinalFormFilters
        onNewAdditionalFilter={onNewAdditionalFilter}
        filters={ADMIN_VEHICLE_LIST_DYNAMIC_FILTERS}
      />
      {hasValues && (
        <Button style={{ marginTop: '18px' }} onClick={() => form.reset({})} variant="contained" color="primary">
          Reset
        </Button>
      )}
    </Wrapper>
  );
};

const FilterSpy = () => {
  const { setFilters } = useVehicleListContext();
  const handleChange = useCallback(
    debounce((state: FormState) => setFilters(state.values || {}), 500),
    [setFilters]
  );
  return <FormSpy onChange={handleChange} />;
};
